import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getAlgorithms } from 'api/algorithms';
import { AlgoSourceMapping } from 'interfaces/algoSourceMapping';

export const useAlgorithms = (
  params: UseQueryOptions<AlgoSourceMapping[], unknown, AlgoSourceMapping[], string[]> = {}
) => useQuery(['algorithms'], ({ signal }) => getAlgorithms(signal), params);
